import React from "react";
import Layout from "@hoc/layouts/Layout";
import ProductSelect from "@components/Product/ProductSelect";

const HomePage = () => {

  return (
    <Layout>
      <ProductSelect />
    </Layout>
  );
}

export default HomePage;
